<div class="offcanvas offcanvas-end" data-bs-scroll="true" tabindex="-1" id="rightSideBar" aria-labelledby="rightSideBarLabel">
  <div class="offcanvas-header">
    <button type="button" class="btn-close" mat-icon-button data-bs-dismiss="offcanvas" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="offcanvas-body">
    <ng-template sideBarHost></ng-template>
  </div>
</div>